<template>
<div class="listw" :class="{'darkmode': darkMode }" >
  <div class="tagsearch" :class="{'tagsearch_show': showSearch}">
    <div class="search-icon icon-search"></div>
    <input type="text"
      ref="searchInput"
      :placeholder="$t('starsPanel.search')"
      class="search-input"
      v-model="keyword">
      <i class="icon icon-del search-del" @click="clearSearchInput" v-if="keyword"></i>
  </div>
  <div class="taglistw  g_scroll" ref="tagsList" @scroll="scrollHandler">
    <Loading  :msg='$t(index.list.loadingText)' v-if="loading"/>
    <div class="list"  v-if="tags">
      <ul class="taglist" v-if="allTags.length && !keyword">
        <li class="item"
          :class="{
            item_active: (item._id === activeTagId || item.active),
            item_choose: index === activeIndex
          }"
          role="button"
          :aria-label="item.name"
          v-for="(item, index) in allTags"
          v-show="!(item.name === '最近删除' && item.num === 0)"
          :key="item._id"
          :ref="index === activeIndex ? 'activeTag' : ''"
          @click="chooseTagHandler(item)">
          <img v-if="item.name === '最近删除'" :src="require('@/assets/trash.svg')" alt="icon" class="item-icon"/>
          <img v-if="item.name === '所有项目'" :src="require('@/assets/bookmark.svg')" alt="icon" class="item-icon"/>
          <img v-if="item.name === '未分类'" :src="require('@/assets/moon.svg')" alt="icon" class="item-icon"/>
          <!-- <img v-else :src="`${HttpRoot}${item.icon}`" alt="icon" class="item-icon"/> -->
          <span class="item-name g_textOverflow" v-if="item.name === '所有项目'">{{$t('index.list.allStars')}}</span>
          <span class="item-name g_textOverflow" v-if="item.name === '未分类'">{{$t('index.list.starWithoutCollect')}}</span>
          <span class="item-name g_textOverflow" v-if="item.name === '最近删除'">{{$t('index.list.starsDel')}}</span>
          <span class="item-num">{{item.pids ? item.pids.length: item.num}}</span>
        </li>
      </ul>
      <ul  class="taglist" v-if="!keyword">
        <div ref="headerRecommend" class="taglist-header g_clearfix_after">
          {{$t('index.list.explore')}}
        </div>
        <div :ref="allTags.length === activeIndex ? 'activeTag' : ''"
          class="item"
          @click="chooseTagHandler('trend')"
          :class="{
            item_active: 'trend' === activeTagId,
            item_choose: activeIndex === allTags.length}">
          <img :src="require('@/assets/bar-chart.svg')" alt="icon" class="item-icon"/>
          <span class="item-name">Trending</span>
        </div>
      </ul>
      <ul class="taglist" >
        <div ref="headerMy" class="taglist-header g_clearfix_after">
          <span class="taglist-header-title">{{$t('index.list.myCollections')}}</span>
          <!-- <span class="taglist-header-line"></span> -->
          <span @click="toggleAddTagToolbar" class="add icon-add" role="button" aria-label="add categories" tabIndex="0"></span>
        </div>
        <EditBar
            v-if="showAddBar"
            :toggleTagToolbar="(item) => toggleEdit(item)"
            :tag="item"
            :showTagToolBar="item.edit"
            :delTagCallback="delTagHandler"
            :editTagCallback="editTagHandler"
            mode='edit_list'
          />
        <li class="item item_self"
          :class="{
            item_active: item._id === activeTagId || item.active,
            item_choose: activeIndex - (allTags.length + 1) === index,
            item_edit: item.edit}"
          role="button"
          @dragover="(e) => dragoverHandler(e, item)"
          @dragleave="(e) => dragleaveHanlder(e, item)"
          @drop="(e) => drophandler(e, item)"
          :aria-label="item.name"
          v-for="(item, index) in myTags"
          :key="item._id"
          :ref="activeIndex - 4 ? 'activeTag' : ''"
          @click="chooseTagHandler(item)">
          <div class="item-con" v-if="!item.edit">
            <img :src="`${HttpRoot}${item.icon}`" alt="icon" class="item-icon"/>
            <span class="item-name g_textOverflow">{{item.name}}</span>
            <span class="item-num" v-if="!item.loading">{{item.pids.length}}</span>
            <span class="item-loading g_loading" v-else>
              <i class="icon-loading"></i>
            </span>
            <span class="item-editbtn icon-pencil" @click.stop="toggleEdit(item)"></span>
          </div>
          <EditBar
            v-else
            :toggleTagToolbar="(item) => toggleEdit(item)"
            :tag="item"
            :showTagToolBar="item.edit"
            :delTagCallback="delTagHandler"
            :editTagCallback="editTagHandler"
            mode='edit_list'
          />
        </li>
      </ul>
      <ul class="taglist" v-if="gitTags.length">
        <div ref="headerGit" class="taglist-header g_clearfix_after">
          <span class="taglist-header-title">{{$t('index.list.githubCollections')}}</span>
          <!-- <span class="taglist-header-line"></span> -->
        </div>
        <li class="item"
          :class="{
            item_active: item._id === activeTagId || item.active,
            item_choose: activeIndex - (allTags.length + 1) - myTags.length === index,
            item_edit: item.edit}"
          role="button"
          :ref="activeIndex - 4 ? 'activeTag' : ''"
          :aria-label="item.name"
          v-for="(item, index) in gitTags"
          :key="item._id"
          @click="chooseTagHandler(item)">
            <img :src="`${HttpRoot}${item.icon}`" alt="icon" class="item-icon"/>
            <span class="item-name g_textOverflow">{{item.name}}</span>
            <span class="item-num">{{item.pids.length}}</span>
        </li>
      </ul>
    </div>
    <CopyRight/>
  </div>
</div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { HttpRoot } from '@/config/'
import Loading from '@/components/Loading'
import CopyRight from '@/components/CopyRight'
import EditBar from '@/components/TagToolBar'

export default {
  components: {
    Loading,
    CopyRight,
    EditBar,
  },
  props: {
    showSearch: Boolean,
    tagSortBy: String,
    toggleStarPanel: Function,
  },
  computed: {
    ...mapState({
      onEventPanel: state => state.event.onEventPanel,
      broadcast: state => state.broadcast,
      tags: state => state.star.tags,
    }),
  },
  data() {
    return {
      loading: false,
      HttpRoot,
      allTags: [],
      myTags: [],
      gitTags: [],
      scrollView: {},
      title: '',
      chooseTag: null,
      activeTagId: '',
      activeIndex: -1,
      keyword: '',
      requestId: '',
      showAddBar: false,
    }
  },
  mounted() {
    if (this.tags) {
      this.tagDataInit()
      this.initScrollData()
      if (this.onEventPanel === '') {
        this.setOnEventPanel('tagList')
        document.addEventListener('keydown', this.onEvent, false)
      }
    }
  },
  watch: {
    keyword(val) {
      this.activeIndex = -1
      const myTags = []
      const gitTags = []
      this.tags.forEach((item) => {
        if (item.type === 'local' && item.name.toLowerCase().indexOf(val) !== -1) {
          myTags.push(item)
        } else if (item.type === 'github' && item.name.toLowerCase().indexOf(val) !== -1) {
          gitTags.push(item)
        }
      })
      this.myTags = myTags
      this.gitTags = gitTags
      this.sortTag()
    },
    showSearch(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.searchInput.focus()
        }, 200)
        document.addEventListener('keydown', this.onEvent, false)
        this.setOnEventPanel('tagList')
      } else {
        this.keyword = ''
        this.activeIndex = -1
        this.$refs.searchInput.blur()
        if (this.$route.name === 'repos') {
          // this.setOnEventPanel('starsPanel')
        }
        // document.removeEventListener('keydown', this.onEvent)
      }
    },
    onEventPanel(val) {
      if (val === 'tagList') {
        document.addEventListener('keydown', this.onEvent, false)
      } else {
        document.removeEventListener('keydown', this.onEvent)
      }
    },
    tagSortBy() {
      this.sortTag()
    },
    $route() {
      this.initActiveId()
    },
    tags(val) {
      this.tagDataInit()
      this.initActiveId()
      this.initScrollData()
    },
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onEvent)
  },
  methods: {
    ...mapMutations({
      setOnEventPanel: 'event/setOnEventPanel',
    }),
    ...mapActions({
      editMultiStar: 'star/editMultiStar',
      newStar: 'star/newStar',
    }),
    toogleSearch(val) {
      const show = val !== undefined ? val : !this.showSearch
      if (show) {
        setTimeout(() => {
          this.$refs.searchInput.focus()
        }, 200)
        document.addEventListener('keydown', this.onEvent, false)
        this.setOnEventPanel('tagList')
      } else {
        this.keyword = ''
        this.activeIndex = -1
        this.$refs.searchInput.blur()
        document.removeEventListener('keydown', this.onEvent)
        this.setOnEventPanel('')
      }
    },
    clearSearchInput() {
      this.keyword = ''
      this.$refs.searchInput.focus()
    },
    onEvent(e) {
      const starIndex = this.keyword ? this.allTags.length : 0
      const tagLength = this.myTags.length + this.gitTags.length + (this.keyword ? this.allTags.length + 1 : 0)
      // 下
      if (e.key === 'ArrowDown' || e.keyCode === 40) {
        e.preventDefault()
        // 搜索的话会从新位置开始
        if (this.keyword && this.activeIndex === -1) this.activeIndex = starIndex
        if (this.activeIndex < tagLength - 1) {
          this.activeIndex += 1
        }
      }

      // 上
      if (e.key === 'ArrowUp' || e.keyCode === 38) {
        e.preventDefault()
        if (this.activeIndex > starIndex) {
          this.activeIndex -= 1
        } else {
          this.activeIndex = -1
        }
      }

      // esc
      if (e.key === 'Escape' || e.keyCode === 27) {
        this.$emit('hideSearch')
        this.activeIndex = -1
        if (this.$route.name === 'repos') {
          // this.setOnEventPanel('starsPanel')
        }
      }

      if ((e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.keyCode === 40 || e.keyCode === 38) &&
      (this.activeIndex > starIndex && this.activeIndex < tagLength)) {
        setTimeout(() => {
          this.animateScroll()
        }, 0)
      }

      // enter
      if ((e.key === 'Enter' || e.keyCode === 13) && this.activeIndex > -1) {
        let tag
        if (this.activeIndex < 3) {
          tag = this.allTags[this.activeIndex]
        } else if (this.activeIndex === 3) {
          tag = 'trend'
        } else if (this.activeIndex < this.allTags.length + this.myTags.length + 1) {
          tag = this.myTags[this.activeIndex - this.allTags.length - 1]
        } else {
          tag = this.gitTags[this.activeIndex - this.myTags.length - this.allTags.length - 1]
        }
        this.chooseTagHandler(tag)
      }
    },
    animateScroll() {
      window.cancelAnimationFrame(this.requestId)
      const list = this.$refs.tagsList
      const listReac = this.$refs.tagsList.getBoundingClientRect()
      const rect = document.querySelector('.taglistw .item_choose').getBoundingClientRect()
      // 获取元素相对窗口的top值，此处应加上窗口本身的偏移
      const top = rect.top - listReac.top - listReac.height + parseInt(listReac.height / 4)
      let currentTop = 0
      const that = this
      const speed = 12
      // 采用requestAnimationFrame，平滑动画
      function step(timestamp) {
        currentTop += speed
        if (currentTop < Math.abs(top)) {
          if (top > 0) {
            list.scrollTop = list.scrollTop + speed
          } else {
            list.scrollTop = list.scrollTop - speed >= 0 ? list.scrollTop - speed : 0
          }
          that.requestId = window.requestAnimationFrame(step)
        } else {
          window.cancelAnimationFrame(that.requestId)
        }
      }
      window.requestAnimationFrame(step)
    },
    dragleaveHanlder(e, tag) {
      e.preventDefault()
      tag.active = false
      this.$forceUpdate()
      // this.activeTagId = ''
    },
    dragoverHandler(e, tag) {
      e.preventDefault()
      tag.active = true
      this.$forceUpdate()
      // this.activeTagId = tag._id
    },
    drophandler(e, tag) {
      e.preventDefault()
      const star = JSON.parse(e.dataTransfer.getData('star'))
      if (star.unStar) {
        tag.loading = true
        this.newStar({
          stars: [star],
        }).then(() => {
          this.addTag(star, tag)
        })
      } else {
        this.addTag(star, tag)
      }
      tag.active = false
      this.$forceUpdate()
    },
    addTag(star, tag) {
      tag.loading = true
      return this.editMultiStar({
        tagsAdd: [tag],
        stars: [star],
      }).then(() => {
        this.$toast({
          msg: this.$t('succ.normal'),
        })
        tag.loading = false
        tag.active = false
        this.$forceUpdate()
      }).catch(() => {
        tag.loading = false
        tag.active = false
        this.$forceUpdate()
      })
    },
    /**
     * 显示添加的toolbar
     */
    toggleAddTagToolbar() {
      this.$emit('toggleAddTagToolbar')
    },
    toggleEdit(item) {
      if (this.editItem && (!item || item._id !== this.editItem._id)) this.editItem.edit = false
      if (item) {
        item.edit = !item.edit
        if (item.edit) this.editItem = item
      }
      this.$forceUpdate()
    },
    editTagHandler(tag) {
      tag.edit = false
    },
    delTagHandler() {
      const tag = this.tags.filter((item) => item.type === 'local_statistics' && item.name === '所有项目')[0]
      this.chooseTagHandler(tag)
    },
    initActiveId() {
      if (this.$route.name === 'repos' && this.$route.query.id) {
        this.activeTagId = this.$route.query.id
      } else if (this.$route.name === 'repos') {
        const tag = this.tags.filter((item) => item.type === 'local_statistics' && item.name === '所有项目')[0]
        if (tag) this.activeTagId = tag._id
      } if (this.$route.name === 'trend') {
        this.activeTagId = 'trend'
      }
    },
    chooseTagHandler(item) {
      if (this.editItem) this.editItem.edit = false

      if (this.activeTagId === item._id) return
      if (item === 'trend') {
        this.$router.push({
          name: 'trend',
        })
        this.activeTagId = 'trend'
      } else {
        this.chooseTag = item
        this.activeTagId = item._id
        this.toggleStarPanel(item)
      }
    },
    // ...mapActions({
    //   getStars: 'star/getStars',
    // }),
    // getTags() {
    //   this.loading = true
    //   return this.getStars().then(() => {
    //     this.loading = false
    //   })
    // },
    initScrollData() {
      this.$nextTick(() => {
        const headerMyRect = this.$refs.headerMy && this.$refs.headerMy.getBoundingClientRect()
        const headerRecommendRect = this.$refs.headerRecommend && this.$refs.headerRecommend.getBoundingClientRect()
        const headerGitRect = this.$refs.headerGit && this.$refs.headerGit.getBoundingClientRect()
        const tagsListRect = this.$refs.tagsList.getBoundingClientRect()
        const scrollViewTop = tagsListRect && tagsListRect.top
        this.scrollView = {
          headerRecommendTop: headerRecommendRect && (headerRecommendRect.top - scrollViewTop) + headerRecommendRect.height,
          headerMyTop: headerMyRect && (headerMyRect.top - scrollViewTop) + headerMyRect.height,
          headerGitTop: headerGitRect && (headerGitRect.top - scrollViewTop) + headerGitRect.height,
        }
      })
    },
    scrollHandler(e) {
      const headerRecommendTop = this.scrollView.headerRecommendTop - e.target.scrollTop
      const headerMyScrollTop = this.scrollView.headerMyTop - e.target.scrollTop
      const headerGitScrollTop = this.scrollView.headerGitTop - e.target.scrollTop
      // 设置为小于5而不是0，提前一点改变
      if (headerRecommendTop && headerRecommendTop <= 5 && headerMyScrollTop > 5) {
        if (this.title !== 'recommend') {
          this.title = 'recommend'
          this.$emit('changeHeaderTitle', this.title)
        }
      } else if (headerMyScrollTop && headerMyScrollTop <= 5 && headerGitScrollTop > 5) {
        if (this.title !== 'my') {
          this.title = 'my'
          this.$emit('changeHeaderTitle', this.title)
        }
      } else if (headerGitScrollTop && headerGitScrollTop <= 5) {
        if (this.title !== 'git') {
          this.title = 'git'
          this.$emit('changeHeaderTitle', this.title)
        }
      } else if (this.title !== 'default') {
        this.title = 'default'
        this.$emit('changeHeaderTitle', this.title)
      }
    },
    tagDataInit() {
      this.allTags = []
      this.myTags = []
      this.gitTags = []
      this.tags.forEach((item) => {
        if (item.type === 'local_statistics') {
          this.allTags.push(item)
        } else if (item.type === 'local') {
          this.myTags.push(item)
        } else if (item.type === 'github') {
          this.gitTags.push(item)
        }
      })
      this.sortTag()
    },
    sortTagsByName(tagA, tagB) {
      return (tagA.name.toLowerCase() > tagB.name.toLowerCase() ? 1 : -1)
    },
    sortTagsByNum(tagA, tagB) {
      return tagB.pids.length - tagA.pids.length
    },
    sortTagsByTime(tagA, tagB) {
      return new Date(tagB.created_at).getTime() - new Date(tagA.created_at).getTime()
    },
    sortTag() {
      if (this.tagSortBy === 'name') {
        this.myTags.sort(this.sortTagsByName)
        this.gitTags.sort(this.sortTagsByName)
      } else if (this.tagSortBy === 'num') {
        this.myTags.sort(this.sortTagsByNum)
        this.gitTags.sort(this.sortTagsByNum)
      } else {
        this.myTags.sort(this.sortTagsByTime)
        this.gitTags.sort(this.sortTagsByTime)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/scss/mixin.scss';

.starslistwrapper{
  border-right: 1px solid rgba(195,195,195,0.50);
}
.listw{
  height: calc(100vh - 202px);
  display: flex;
  flex-direction: column;
}
//tagsearch
.tagsearch{
  transition: 0.2s ease;
  position: relative;
  height: 0;
  overflow: hidden;
  opacity: 0;
  visibility: hidden;
  margin: 0 10px;
  box-sizing: border-box;
  .search-input{
    border-radius: 99px;
    background: #EBEBEB;
    box-sizing: border-box;
    height: 20px;
    border: 1px solid #e1e1e1;
    padding: 2px 24px;
    line-height: 16px;
    flex: 1;
    width: 100%;
    font-size: 12px;
    outline: none;
    transition:box-shadow 0.2s ease;
    color: #3C3D3C;
    @include placeholderMixin(#A6A6A6, 12px);
    &:focus{
      // box-shadow: 0 0 4px rgba(97, 97, 97, 0.8);
      border-color: #E6E6E6;
    }
  }
  .search-icon{
    position: absolute;
    left: 6px;
    top: 3px;
    font-size: 12px;
    color: #7B7B7B;
  }
  .search-del{
    font-size: 12px;
    position: absolute;
    top: -1px;
    right: -1px;
    cursor: pointer;
    padding: 4px;
    &:hover:before{
      background: rgba(70, 70, 70, 0.379);
    }
    &::before{
      width: 14px;
      height: 14px;
      color: #8c8c8c;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 999px;
      background: rgba(198, 198, 198, 0.38);
    }
  }
}

.tagsearch_show{
  height: 28px;
  margin: 0px 15px 4px;
  opacity: 1;
  flex-shrink: 0;
  visibility: visible;
}

// taglistw
.taglistw{
  flex:1;
  padding:0 10px;
  animation: fadeOut 0.2s cubic-bezier(0.4, 0, 1, 1);
  display: flex;
  flex-direction: column;
}
.list{
  flex: 1;
}
.taglist{
  padding-bottom: 14px;
}
.taglist-header{
  line-height: 20px;
  font-size: 14px;
  color: #494949;
  padding-bottom: 8px;
  .add{
    width: 22px;
    height: 15px;
    margin-top: 2px;
    color: #7B7B7B;
    text-align: center;
    line-height: 15px;
    float: right;
    font-size:12px;
    background: #EBEBEB;
    border-radius: 2px;
    margin-left:5px;
    cursor: pointer;
    &:hover{
      background: #D9D9D9;
    }
  }
}
.taglist-header-title{
  float: left;
  padding-right: 10px;
  -webkit-font-smoothing: antialiased;
}
.taglist-header-line{
  display: block;
  overflow: hidden;
  padding-top: 8px;
  border-bottom: 1px solid #FFFFFF;
  box-shadow: 0 0.5px 0 0 #EFEFEF;
}
.item{
  display: block;
  line-height: 24px;
  padding: 0 5px;
  margin: 6px 0 6px 0;
  border-radius: 4px;
  position: relative;
  cursor: pointer;
  // transition: background 0.5s ease;
  &:hover{
    background:#dadada;

  }
}

.item_choose{
  background:#e9e9e9;
}
.item_active{
  background:#dadada;
}
.item_self{
  &:hover{
    .item-num{
      display: none;
    }
    .item-editbtn{
      display: block;
    }
  }
}
.item_edit{
  padding: 0;
  background: none;
  &:hover{
    background:none;
  }
}
.item-icon{
  width: 16px;
  height: 16px;
  margin-right: 8px;
  margin-top: 5px;
  float: left;
}
.item-name{
  width: 160px;
  // 因为overflow：hidden，导致baseline直接在bottom
  vertical-align:top;
  font-size: 14px;
  color: #484848;
  display: inline-block;
}
.item-editbtn,
.item-num{
  float: right;
  font-size: 12px;
  color: #9B9B9B;
  position: absolute;
  right: 5px;
  top: 0;
}
.item-loading{
  color: #9B9B9B;
  font-size: 12px;
  position: absolute;
  right: 5px;
  top: 0;
}
.item-editbtn{
  padding-left:5px;
  display: none;
  line-height: 24px;
}

/** bigmode */
.bigmode{
  border-right: 1px solid #414141;
  .taglistw{
    height: 394px; //250
  }
  .taglist-header{
    font-size: 14px;
    padding: 8px 5px;
  }
  .item{
    line-height: 26px;
    margin: 3px 0;
  }
  .item-icon{
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
  .item-name{
    font-size: 14px;
    color: #646464;
  }
  .item-num{
    font-size: 14px;
  }
}

/** darkmode **/
.darkmode{
  // tagsearch
  .tagsearch{
     .search-input{
      background: #1f1e1e;
      border: 1px solid #1f1f1f;
      color: #fff;
      @include placeholderMixin(#414141, 14px);
      &:focus{
        font-weight: bold;
        box-shadow: 0 0 1px rgba(171, 171, 171, 0.4);
        border-color: #1f1f1f;
      }
    }
    .share-input{
      background: #7d7d7d;
      color: #fff;
      box-shadow: inset 0 0 4px #515151;
      @include placeholderMixin(#fff, 12px);
    }
  }
  .taglist-header{
    color: #8B8B8B;
    .add{
      color: #FFFFFF;
      background: #5D5D5D;
      &:hover{
        background: #8E8E8E;
      }
    }
  }
  .taglist-header-line{
    padding-top: 9px;
    box-shadow: 0 0.5px  #4F4F4F;
    border: none;
  }
  .item{
    &:hover {
      background: #494949;
    }
  }
  .item_choose{
    background: #8c8b8b;
  }
  .item_active{
    background: #494949;
  }
  .item-name{
    color: #E2E2E2;
  }
}
</style>
